(function () {
  'use strict';
  const host = document.querySelector('[data-hgb-upsell-host]');
  const form = document.getElementById('CartDrawerForm');
  if (!host || !form) return;
  const status = form.querySelector('[data-hgb-upsell-status]');
  const products = form.querySelector('[data-products]');
  let busy = false, sequence = 0, timer;
  async function refresh() {
    const ticket = ++sequence;
    try {
      const response = await fetch(host.dataset.sectionUrl, {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) throw new Error('recommendations');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-hgb-upsell-content]');
      if (ticket !== sequence || busy) return;
      host.replaceChildren(...(content ? Array.from(content.childNodes) : []));
    } catch (_) {
      if (ticket === sequence && !busy) host.replaceChildren();
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 100); }
  host.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-hgb-upsell-add]');
    if (!button || busy) return;
    event.preventDefault();
    const id = Number(button.dataset.hgbUpsellAdd);
    const productId = Number(button.dataset.productId);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(productId)) return;
    busy = true; sequence++;
    const controls = Array.from(form.querySelectorAll('button, input[type="submit"]')).map(el => [el, el.disabled]);
    controls.forEach(([el]) => { el.disabled = true; });
    status.textContent = host.dataset.adding;
    try {
      const check = await fetch(host.dataset.cartUrl, {credentials: 'same-origin', cache: 'no-store'});
      if (!check.ok) throw new Error('cart');
      const cart = await check.json();
      if (!Array.isArray(cart.items)) throw new Error('cart');
      if (!cart.items.some(item => Number(item.product_id) === productId && item.quantity > 0)) {
        const response = await fetch(host.dataset.addUrl, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items:[{id,quantity:1}]})});
        if (!response.ok) throw new Error('add');
        await response.json();
      }
      status.textContent = host.dataset.added;
    } catch (_) {
      status.textContent = host.dataset.error;
    } finally {
      busy = false;
      controls.forEach(([el, disabled]) => { el.disabled = disabled; });
      document.dispatchEvent(new CustomEvent('cart:build'));
      schedule();
    }
  });
  form.addEventListener('submit', event => { if (busy) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
  form.addEventListener('click', event => { if (busy && event.target.closest('[name="checkout"]')) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
  if (products) new MutationObserver(schedule).observe(products, {childList:true});
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxProduct:added', schedule);
  document.addEventListener('cart:open', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
}());
